// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Isaias (Isaiah)",
  bookSlug: "isaias",
  chapter: 12,
  argument: "A canticle of thanksgiving for the benefits of Christ.",
  verses: [
    { n: 1, text: "And thou shalt say in that day: I will give thanks to thee, O Lord, for thou wast angry with me: thy wrath is turned away, and thou hast comforted me." },
    { n: 2, text: "Behold, God is my Saviour, I will deal confidently, and will not fear: because the Lord is my strength, and my praise, and he is become my salvation." },
    { n: 3, text: "You shall draw waters with joy out of the Saviour's fountains:" },
    { n: 4, text: "And you shall say in that day: Praise ye the Lord, and call upon his name: make his works known among the people: remember that his name is high." },
    { n: 5, text: "Sing ye to the Lord, for he hath done great things: shew this forth in all the earth." },
    { n: 6, text: "Rejoice, and praise, O thou habitation of Sion: for great is he that is in the midst of thee, the holy one of Israel." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Thanks. Literally, \"confess.\" The Jews thank God for their return, as the Church does for her deliverance from sin. (Worthington) — Canticles were composed on such occasions, Exodus xv. — Angry. They do not thank God on this account; but because he had averted his indignation.", attribution: "Calmet" }
    ] },
    { verse: 3, notes: [
      { text: "Fountains. Instead of those which your fathers drank in the desert. (Calmet) — You shall have the holy Scriptures, (Haydock) sacraments, &c., John iv. 13., and vii. 38.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Of thee. He alludes to the name Emmanuel. Christ preached, and his own would not receive him, John i. 11., and 26. (Calmet) — He continues with us, concealed under the sacramental species [of the Eucharist].", attribution: "Menochius" }
    ] },
  ],
};

export default chapter;
